import { render, staticRenderFns } from "./ImportTemplatesOverview.vue?vue&type=template&id=a38d26ee&scoped=true&"
import script from "./ImportTemplatesOverview.vue?vue&type=script&lang=js&"
export * from "./ImportTemplatesOverview.vue?vue&type=script&lang=js&"
import style0 from "./ImportTemplatesOverview.vue?vue&type=style&index=0&id=a38d26ee&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38d26ee",
  null
  
)

export default component.exports